module.exports = __webpack_public_path__ + "static/15-e89a830b44a57c58bc991a6053761dcb.png";